import React from "react";
import "./Privacy.css";

const DeleteData = () => {
  return (
    <div className="privacy-container">
      <h1>Delete Your Data</h1>
      <div className="privacy-content">
        <h2>How to Delete Your Data</h2>
        <p>To delete your connected account data:</p>
        <ol>
          <li>Install Flateroo</li>
          <li>Log in to your account</li>

          <li>
            Disconnect Spotify
            <ul>
              <li>Go to "Edit Profile" in your account settings</li>
              <li>Click "Disconnect Spotify" to remove Spotify data</li>
            </ul>
          </li>
          <li>
            Delete Account and all associated data
            <ul>
              <li>Go to the "Settings" and select "Account"</li>
              <li>Click "Delete Account" to remove all data and account</li>
            </ul>
          </li>
        </ol>

        <h2>Need Help?</h2>
        <p>
          If you have any questions or need assistance, please contact us at{" "}
          <a href="mailto:support@flateroo.com">support@flateroo.com</a>
        </p>
      </div>
    </div>
  );
};

export default DeleteData;
